import { Component, Ref } from 'react';

import { FormControl } from '../../../../models/forms';
import { untilDestroyed } from '../../../../utils/until-destroyed';
import { OptionalChildrenProps } from '../../../../types/react.types';

const defaultProps: any = {
    type: 'text',
}

export interface FormInputComponentProps extends OptionalChildrenProps {
    id?: string;
    type: 'text' | 'email' | 'number';
    control: FormControl;
    placeholder?: string;
    className?: string;
    inputRef?: Ref<HTMLInputElement>;
    autoComplete?: string;
    'aria-describedby'?: string;
    'aria-invalid'?: boolean;
}

export interface FormInputComponentState {
    value: any,
}

export default class FormInputComponent extends Component<FormInputComponentProps, FormInputComponentState> {
    mergedProps: FormInputComponentProps = defaultProps;

    readonly state: Readonly<FormInputComponentState> = {
        value: this.props?.control?.value || null,
    };
    constructor(props: FormInputComponentProps) {
        super(props);
        this.mergedProps = Object.assign({}, defaultProps, props);
        props.control.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (value) => {
                    this.setState({ value })
                }
            });
    }

    render() {
        return <input
            id={this.mergedProps.id}
            type={this.mergedProps.type}
            placeholder={this.mergedProps.placeholder}
            className={this.mergedProps.className}
            ref={this.props.inputRef}
            autoComplete={this.props.autoComplete}
            aria-describedby={this.props['aria-describedby']}
            aria-invalid={this.props['aria-invalid'] || undefined}
            value={this.state.value} onInput={(e: any) => this.props.control.setValue(e.target.value)}
        />
    }
}